import { Modal, Alert, Button } from "react-bootstrap";

const WarningPanel = ({ show, clusterCodeWarningsWarningList =[], clusterCodeWarningsErrorList= [], onClose }) => {
  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">
          ⚠️ Please Review the Warnings and Errors
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "350px", overflowY: "auto" }}>
        {clusterCodeWarningsWarningList.map((w, index) => (
          <Alert key={index} variant="warning" className="mb-2">
            {w}
          </Alert>
        ))}
        {clusterCodeWarningsErrorList.map((w, index) => (
          <Alert key={index} variant="danger" className="mb-2">
            {w}
          </Alert>
        ))}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WarningPanel;
